// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Loader from './Loader';

const DashboardModalLoader = ({ size = 'lg' }) => (
  <div
    className="dashboard-modal-overlay-loader"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <Loader size={size} />
  </div>
);

export default DashboardModalLoader;
